import { FILE_UPLOAD_URL } from './api';
import { getToken } from './storage';

const SIGNUP_IMAGE_UPLOAD_URL = FILE_UPLOAD_URL.replace(
  '/write/v1/image/upload',
  '/write/v3/image/upload'
);

/** FormData `type` value for profile image */
export const SIGNUP_IMAGE_UPLOAD_TYPE_PROFILE = 1;
/** FormData `type` value for driver license image */
export const SIGNUP_IMAGE_UPLOAD_TYPE_DRIVER_LICENSE = 2;
/** FormData `type` value for business license image */
export const SIGNUP_IMAGE_UPLOAD_TYPE_BUSINESS_LICENSE = 3;

/**
 * Signup-only image upload: POST /write/v3/image/upload with `image` + `type` (1 | 2 | 3).
 * Does not use the shared {@link uploadFile} helper so other flows stay on v1.
 *
 * @param {File} file
 * @param {typeof SIGNUP_IMAGE_UPLOAD_TYPE_PROFILE | typeof SIGNUP_IMAGE_UPLOAD_TYPE_DRIVER_LICENSE | typeof SIGNUP_IMAGE_UPLOAD_TYPE_BUSINESS_LICENSE} imageType
 * @returns {Promise<Record<string, unknown>>}
 */
export function uploadSignupImage(file, imageType) {
  const form = new FormData();
  form.append('image', file);
  form.append('type', String(imageType));

  return new Promise((resolve, reject) => {
    fetch(SIGNUP_IMAGE_UPLOAD_URL, {
      headers: {
        Accept: 'application/json',
        token: getToken(),
      },
      method: 'POST',
      body: form,
    })
      .then((response) => {
        if (response.status === 401) {
          // match uploadFile behavior (no redirect here for public signup)
        } else if (response.status >= 400) {
          reject(response);
          return;
        }
        response.json().then((data) => {
          resolve(data);
        });
      })
      .catch((e) => {
        console.log('ERROR', e);
        reject(e);
      });
  });
}
